const appConfig = {
  "name": "mitid-v2-test",
  "version": "0.1.0",
  "stage": "test",
  "deployThisBuild": false,
  "okta": {
    "issuer": "https://okta.mit.edu/oauth2/aus6shd5478WH30vd697",
    "clientId": "729sqp8787j0m2ptmvg290fgdm",
    "redirectUris": [
      "https://mitid-test.mit.edu",
      "https://mitid.atlas-apps-test.mit.edu"
    ],
    "postLogoutRedirectUris": [
      "https://mitid-test.mit.edu/logout",
      "https://mitid.atlas-apps-test.mit.edu/logout"
    ],
    "scopes": [
      "address",
      "email",
      "mit:user:all.manage",
      "mit:user:all.read",
      "mit:user:mitid.manage",
      "offline_access",
      "openid",
      "phone",
      "profile"
    ]
  },
  "amplify": {
    "userPoolId": "us-east-1_nY154N4yV",
    "userPoolWebClientId": "729sqp8787j0m2ptmvg290fgdm",
    "oauth": {
      "domain": "atlas-auth-test.mit.edu",
      "scope": [
        "digital-id/search",
        "digital-id/user",
        "mitid/user",
        "openid",
        "profile",
        "user/all"
      ],
      "redirectUris": [
        "https://mitid-test.mit.edu",
        "https://mitid.atlas-apps-test.mit.edu"
      ],
      "postLogoutRedirectUris": [
        "https://mitid-test.mit.edu/logout",
        "https://mitid.atlas-apps-test.mit.edu/logout"
      ],
      "responseType": "token",
      "options": {
        "AdvancedSecurityDataCollectionFlag": false
      }
    }
  }
};
export default appConfig;